import React, { useState, useEffect } from 'react';
import { useSearchParams } from '~/infrastructure/mam/Router';
import { getNotificationsDetail } from '~/libs/infrastructure/api/notifications';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';
import { NotificationsDetailResponse } from '~/libs/infrastructure/schemas';

export function NotificationsDetail() {
	const params = useSearchParams();
	const notificationId = params.get('notificationId') ?? '';
	const notificationEmailId = params.get('emailNotificationId') ?? '';
	const [result, setResult] = useState<NotificationsDetailResponse | string>('');

	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		getNotificationsDetail(notificationId, notificationEmailId)
			.then((data) => {
				setResult(data);
				setLoading(false);
			})
			.catch(() => {
				setError(true);
			});
	}, [notificationEmailId]);

	return (
		<>
			{!error && loading && (
				<div style={{ textAlign: 'center', padding: '20px' }}>
					<SpinningLoadingIcon />
				</div>
			)}
			{!error && !loading && <div dangerouslySetInnerHTML={{ __html: result }} />}
		</>
	);
}
